import { AspectRatio } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import Video from '~/components/Video';
import { useLazyLoad } from '~/hooks/useLazyLoad';

/**
 * @param {{ containerProps: object, fallbackSrc?: string, ratio?: number, src?: string, videoProps: object,showPlayIcon:boolean, [index: string]: any}} props
 */
export const LazyVideo = ({
  containerProps = {},
  fallbackSrc,
  ratio = 1,
  src,
  videoProps = {},
  showPlayIcon,
  ...aspectRatioProps
}) => {
  const { ref, src: videoSrc } = useLazyLoad({ fallbackSrc, src });
  return (
    <AspectRatio ratio={ratio} {...aspectRatioProps}>
      <Video
        showPlayIcon={showPlayIcon}
        ref={ref}
        src={videoSrc}
        containerProps={{ position: 'absolute', ...containerProps }}
        {...videoProps}
      />
    </AspectRatio>
  );
};

LazyVideo.propTypes = {
  containerProps: PropTypes.shape({}),
  fallbackSrc: PropTypes.string,
  ratio: PropTypes.number,
  src: PropTypes.string,
  videoProps: PropTypes.shape({}),
  showPlayIcon: PropTypes.bool,
};
